// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom"; 
// import translations from "../i18n/translations";
// import logo from "../Asset/logo.svg";
// import "./Header.css";

// const Header = () => {
//   const [lang, setLang] = useState("en");
//   const t = translations[lang] || translations.en;

//   const navigate = useNavigate();

//   const token = localStorage.getItem("token");

//   const handleLogout = () => {

//     localStorage.removeItem("token");
//     localStorage.removeItem("id");


//     navigate("/login");

//   };

//   const toggleLanguage = (language) => {
//     setLang(language);
//   };

//   return (
//     <header className="app-header">
//       <div className="header-container">

//         {/* Logo & Brand Text Section */}
//         <Link to="/" className="brand-wrapper">
//           <div className="logo-container">
//             <img src={logo} alt="Shivsena Logo" className="app-logo" />
//           </div>
//           <div className="brand-text">
//             <h1 className="brand-title">शिवसेना पिंपरी चिंचवड शहर</h1>
//             <p className="brand-address">
//               शिवसेना मध्यवर्ती कार्यालय,रॉयल रोहना जुना जकात नाका,वाल्हेकरवाडी रोड चिंचवडगाव पुणे-33
//             </p>
//           </div>
//         </Link>

//         {/* Navigation & Actions Section */}
//         <nav className="nav-actions">

//           {/* 5. Conditional Rendering: Token hai to LOGOUT, nahi to LOGIN */}
//           {token ? (
//             <button
//               onClick={handleLogout}
//               className="btn-login"
//               style={{ cursor: "pointer" }} // Button style fix
//             >
//               Logout
//             </button>
//           ) : (
//             <Link to="/login" className="btn-login">
//               {t.login || "Login"}
//             </Link>
//           )}

//         </nav>
//       </div>
//     </header>
//   );
// };

// export default Header;
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaUserTie } from "react-icons/fa"; // ✅ Import Icon
import translations from "../i18n/translations";
import logo from "../Asset/logo.svg";
import "./Header.css";

const Header = () => {
  const [lang, setLang] = useState("en");
  const t = translations[lang] || translations.en;
  const navigate = useNavigate();

  // Get Token and Role from LocalStorage
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role"); 

  const handleLogout = () => {
    localStorage.clear(); // Clear all data (token, role, id)
    navigate("/login");
  };

  // Logic to determine where the user goes when clicking the icon
  const getDashboardPath = () => {
    switch (role) {
      case "superAdmin":
        return "/superadmin-dashboard";
      case "Admin":
        return "/admin-dashboard";
      case "candidate":
        return "/candidate-dashboard";
      default:
        return "/dashboard";
    }
  };

  return (
    <header className="app-header">
      <div className="header-container">

        {/* Logo & Brand Text Section */}
        <Link to="/" className="brand-wrapper">
          <div className="logo-container">
            <img src={logo} alt="Shivsena Logo" className="app-logo" />
          </div>
          <div className="brand-text">
            <h1 className="brand-title">शिवसेना पिंपरी चिंचवड शहर</h1>
            <p className="brand-address">
              शिवसेना मध्यवर्ती कार्यालय, रॉयल रोहना जुना जकात नाका, वाल्हेकरवाडी रोड चिंचवडगाव पुणे-33
            </p>
          </div>
        </Link>

        {/* Navigation & Actions Section */}
        <nav className="nav-actions">

          {/* ✅ DASHBOARD LINK WITH ICON */}
          {token && (
            <Link 
              to={getDashboardPath()} 
              className="dashboard-link"
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "2px",
                textDecoration: "none",
                color: "#ff9933", // Saffron color or whatever fits your theme
                fontWeight: "bold",
                fontSize: "16px"
              }}
            >
               {/* Icon */}
               <FaUserTie style={{ fontSize: "2rem" }} />
               
               {/* Text based on Role */}
               <span>
                 {role === 'Admin' || role === 'superAdmin' ? '' : ''}
               </span>
            </Link>
          )}

          {/* LOGOUT / LOGIN BUTTON */}
          {token ? (
            <button
              onClick={handleLogout}
              className="btn-login"
              style={{ cursor: "pointer" }}
            >
              Logout
            </button>
          ) : (
            <Link to="/login" className="btn-login">
              {t.login || "Login"}
            </Link>
          )}

        </nav>
      </div>
    </header>
  );
};

export default Header;